<template>
  <div>
    <div v-if="showloading">

      <loader-appie/>

    </div>
    <div v-else>

<!--      <log-in-header @toggleSidebar="toggleSidebar"/>-->
      <section class=" " id="testimonial">

      <div class="container">

<div class=" ">
  <div v-if="insideloader" class="loader-overlay">
    <loader-appie />
  </div>
  <div class="row">
    <div class="col-12 p-5 col-md-6  order-2 order-md-1" md="6" >
      <div class="text-center" >
<!--      <img src="https://d314xssrurywid.cloudfront.net/bTe00Q6l1UeDW2VvJzWcPVD7DQBQabO7mE3Hft5U.webp" width="80%" height="80%" >-->
      <img src="https://d2hy6ree306xec.cloudfront.net/employer_files/company_proof/TV3cHGIWCcbDvPQzQB35t8kVQZlQMtHqR1feFkW2.svg" width="80%" height="80%" >
      </div>
        <!--              <testimonial-login :sliderContents="localSliderContents"/>-->
    </div>
    <div class="col-12 p-5 loginright col-md-6  order-1 order-md-2"  md="6" >

      <div class="mt-3">
      <h1 class="h1title">Post Your <span class="redhead">Jobs With Us</span></h1>
      <p style="text-align: left" class="mt-2 boldfont">Trust by 85K+ Employers</p>
      <div class="cardshawdow mt-4">
        <div v-if="numberdiv">
        <form @submit.prevent="submitForm">
          <div class="row">
            <div class="col-12  mx-auto">
              <label for="mobile" class="boldfont" >Login Your Account With Mobile Number</label>
              <b-form-input
                  class="mt-1"
                  id="mobileNumber"
                  v-model="mobileno"
                  type="number"
                  @input="validateMobileNumber"
                  :formatter="formatterFunction"
                  placeholder="Mobile Number"
                  oninput="this.value = this.value.replace(/^0/, '');this.value = this.value.replace(/^[^6-9][0-9]*/, '');"
                  required
                  ref="mobileInput"
                  autofocus
              ></b-form-input>
              <span v-if="isMobileErrorMsg"  class="mt-2" style="color: red;">Enter a valid 10-digit mobile number</span>
            </div>
          </div>


          <div class="row">
            <div class="col-12">
              <div class="pricing-btn mt-3 ">
                <b-button class="sendotp" type="submit" :disabled="!isMobileValid"><b>LOGIN NOW</b></b-button>
              </div>
            </div>
          </div>

        </form>

      </div>

      <div v-if="otpdiv" style="text-align: center">
<!--      <div style="text-align: center">-->
        <b class=" mb-4" style="font-size: 18px">Enter Verification Code</b>

        <div class="text-body-2">
          Enter 6 digit OTP number sent to your mobile number
        </div>
        {{ GetMobileNumber }}


<!--        <b-form-input-->
<!--            v-model="otp"-->
<!--            type="number"-->
<!--            @input="validateotp"-->
<!--            :formatter="formatterotp"-->
<!--            placeholder="Enter verification code"-->
<!--            variant="outline"-->
<!--            required-->
<!--        ></b-form-input>-->
        <vue-simple-otp-input
            v-model="otp"
            type="number"
            @input="validateotp"
            :formatter="formatterotp"
            required
            :length="6"
            class="otp-input"
            @keypress="onlyNumber"
            ref="otpInput"/>

        <span v-if="isinavalidotp" style="color: red;">The OTP you have entered is invalid</span>

        <span v-if="isOtpErrorMsg" style="color: red;">Enter a 6-digit Otp</span><br>
        <!--            <div class="row" v-if="timeRemaining > 0">-->
        <div class="row mt-4">
          <div v-if="timeRemaining > 0" class="col-12 col-md-8">Resend OTP in <span style="color: red">{{ formatTime(timeRemaining) }}</span></div>
          <div class="text-caption col-12 col-md-8 "  v-if="timeRemaining <= 0">
            Didn't receive the code? <a href="#" style="color: red !important;text-decoration: underline" @click="ResendOtp">Resend</a>
          </div>
<!--          <div class="col-12 col-md-4">-->


<!--            <b-button class="VerifyOtp" type="submit" @click="VerifyOtp" :disabled="!isOtpValid"><b>Verify OTP</b></b-button>-->

<!--            &lt;!&ndash;                  <b-button pill variant="warning" type="submit" @click="VerifyOtp" :disabled="!isMobileValid"><b>Verify&ndash;&gt;-->
<!--            &lt;!&ndash;                    OTP</b></b-button>&ndash;&gt;-->

<!--          </div>-->

        </div>
        <!--            <div class="text-caption" v-else>-->
      </div>

      </div>
      <div class="pricing-btn mt-5 text-center"  v-if="numberdiv">
        <span>By Continuing you agree to </span> <br>
        <span><a href="https://nithrajobs.com/tc_employer_posting.php" style="color: blue !important;">Terms and Conditions</a></span> & <span><a href="https://www.nithra.mobi/privacy.php" style="color: blue !important;">Privacy Policy</a></span>
      </div>
      </div>




    </div>

  </div>



</div>

      </div>
      </section>
      <br>

      <div class="back-to-top">
        <a href="#"><i class="fal fa-arrow-up"></i></a>
      </div>
      <!--====== APPIE BACK TO TOP PART ENDS ======-->
      <!--Modal Start-->
      <div>

        <b-modal id="my-modal" ref="myModal" class="centered-modal" no-close-on-backdrop>
          <!--        <b-modal id="my-modal" @hide="onModalHide" ref="myModal">-->
          <span>கீழே உள்ள தொலைபேசி எண் சரி எனில் continue-வை கிளிக் செய்யவும். <br> தவறு எனில் Edit-கிளிக் செய்யவும்</span>
          <div class="row">
            <div class="col-12 col-md-6 mx-auto">
              <div class="pricing-btn mt-3 text-center">
                <span>{{ GetMobileNumber }}  </span>

              </div>
            </div>

          </div>

          <div class="row">

            <div class="col-12 col-md-6 mx-auto">
              <div class="pricing-btn mt-3 ">
              <b-button  @click="mobileNumberEditButton"  class="editbtn"><i class="fa fa-pencil"
                                                                             aria-hidden="true"></i> Edit
              </b-button>
              </div>
            </div>
            <div class="col-12 col-md-6 mx-auto">
              <div class="pricing-btn mt-3 ">
                <b-button variant="primary" @click="OtpModal" v-if="iscontinue">Continue</b-button>
              </div>
            </div>
          </div>
          <span v-if="delectedAc" style="color: red;text-align: center">{{delMsg}}</span>


        </b-modal>
      </div>
      <!--Modal Start End-->

      <!--Otp Modal Start-->
      <div>

<!--        <b-modal id="modal-center" ref="myModal1" centered title="BootstrapVue" no-close-on-backdrop >-->
<!--          &lt;!&ndash;          <p class="my-4">Vertically centered modal!</p>&ndash;&gt;-->

<!--&lt;!&ndash;          <b-card&ndash;&gt;-->
<!--&lt;!&ndash;              class="py-8 px-6 text-center mx-auto ma-4"&ndash;&gt;-->
<!--&lt;!&ndash;              bg-variant="light"&ndash;&gt;-->
<!--&lt;!&ndash;              text-variant="dark"&ndash;&gt;-->
<!--&lt;!&ndash;              border-variant="secondary"&ndash;&gt;-->
<!--&lt;!&ndash;              shadow="lg"&ndash;&gt;-->
<!--&lt;!&ndash;              max-w="400"&ndash;&gt;-->
<!--&lt;!&ndash;              w="100%"&ndash;&gt;-->
<!--&lt;!&ndash;          >&ndash;&gt;-->
<!--            <div class="cardshawdow">-->
<!--            <h3 class="text-h6 mb-4">Enter Verification Code</h3>-->

<!--            <div class="text-body-2">-->
<!--              Enter 6 digit OTP number sent to your mobile number-->
<!--            </div>-->
<!--            {{ GetMobileNumber }}-->


<!--              <b-form-input-->
<!--                  v-model="otp"-->
<!--                  type="number"-->
<!--                  @input="validateotp"-->
<!--                  :formatter="formatterotp"-->
<!--                  placeholder="Enter verification code"-->
<!--                  variant="outline"-->
<!--                  required-->
<!--              ></b-form-input>-->

<!--            <span v-if="isinavalidotp" style="color: red;">The OTP you have entered is invalid</span>-->

<!--            <span v-if="isOtpErrorMsg" style="color: red;">Enter a 6-digit Otp</span><br>-->





<!--            &lt;!&ndash;            <div class="row" v-if="timeRemaining > 0">&ndash;&gt;-->
<!--            <div class="row">-->
<!--              <div v-if="timeRemaining > 0" class="col-12 col-md-8">Resend OTP in <span style="color: red">{{ formatTime(timeRemaining) }}</span></div>-->
<!--              <div class="text-caption col-12 col-md-8 "  v-if="timeRemaining <= 0">-->
<!--                Didn't receive the code? <a href="#" style="color: red !important;text-decoration: underline" @click="ResendOtp">Resend</a>-->
<!--              </div>-->
<!--              <div class="col-12 col-md-4 ">-->


<!--                  <b-button class="VerifyOtp" type="submit" @click="VerifyOtp" :disabled="!isOtpValid"><b>Verify OTP</b></b-button>-->

<!--&lt;!&ndash;                  <b-button pill variant="warning" type="submit" @click="VerifyOtp" :disabled="!isMobileValid"><b>Verify&ndash;&gt;-->
<!--&lt;!&ndash;                    OTP</b></b-button>&ndash;&gt;-->

<!--              </div>-->

<!--            </div>-->
<!--            &lt;!&ndash;            <div class="text-caption" v-else>&ndash;&gt;-->
<!--            </div>-->
<!--&lt;!&ndash;          </b-card>&ndash;&gt;-->
<!--        </b-modal>-->
      </div>
      <!--Otp Modal End-->
    </div>
  </div>

</template>

<script>

import testmonialAvater from "@/assets/images/testimonial-user.png"
import traffic_thumb from '@/assets/images/traffic-thumb.png'

// import LogInHeader from './LogInHeader.vue'

// import TestimonialLogin from './TestimonialLogin.vue'

import LoaderAppie from '../LoaderAppie.vue'
import {callAxios} from '@/main.js';
import CryptoJS from "crypto-js";
import VueSimpleOtpInput from 'vue-simple-otp-input';
import "vue-simple-otp-input/dist/vue-simple-otp-input.css";
export default {
  name: 'LogIn',
  components: {
    // LogInHeader,
    // SidebarHomeOne, HeroHomeOne, ServicesHomeOne, FeaturesHomeOne, TrafficHomeOne, TestimonialHomeOne, TeamHomeOne,
    // PriceingHomeOne, FaqHomeOne, BlogHomeOne, ProjectHomeOne, FooterHomeOne,
    // TestimonialLogin,
    LoaderAppie,
    VueSimpleOtpInput,
  },
  data() {
    return {
      insideloader:false,
      otpdiv:false,
      numberdiv:false,
      delMsg:'',
      delectedAc:0,
      iscontinue:1,
      timeRemaining: 60, // Time in seconds
      timerInterval: null,
      otp: '',

        mobileno : '',
        GetMobileNumber : '',
        isMobileValid: false,
        isMobileErrorMsg:true,
        isOtpErrorMsg:true,
      isinavalidotp:false,

      isOtpValid:false,

      traffic_thumb:traffic_thumb,
        testmonialAvater:testmonialAvater,
        sidebar:false,
        showloading:true,


    localSliderContents: [],
        loadingImage: [],
        splash_screen: [],

  }
  },
  // mounted() {
  //
  // },
  async created() {
    this.preLoading();
    this.numberdiv=true;
    document.addEventListener('scroll', this.topToBottom)

    try {
      const demoDatas = await callAxios('https://jobspro.nithrajobs.com/api/auth/slider', '', 'post');
      // console.log(demoDatas);
      this.loadingImage = demoDatas;
      this.splash_screen = demoDatas.splash_screen;
      console.log(this.splash_screen)
      this.localSliderContents = demoDatas.slider || [];

      localStorage.setItem('carousel', JSON.stringify(demoDatas.slider));

      // console.log(this.localSliderContents)
      // Handle the data as needed
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Handle 401 status silently
        // For example, do nothing or log a message without displaying it
      } else {
        // Handle other errors by displaying them
        console.error('Error in Axios request:', error);
      }
    }


  },


  methods: {

    onlyNumber($event) {

      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },

    async OtpModal() {

      try {
        this.insideloader = true;
        const otpdata = await callAxios('https://jobspro.nithrajobs.com/api/auth/register', {
          phonenumber: this.mobileno
        }, 'post');
        this.insideloader = false;
        // console.log('otpdata',otpdata);
        // "status": false,
        //     "message": "Your account is deleted., contact : 04448133200",
        //     "errors": "deleted"
        if(otpdata.status==true){
          this.numberdiv=false;
          this.delectedAc=0;
          this.$refs.myModal.hide();
          // this.$refs.myModal1.show();
          this.otpdiv=true;
          // this.$nextTick(() => { // Ensure DOM update is complete
          //   console.log('affected')
          //   this.$refs.otpInput.focus();
          // });
          this.timeRemaining = 60;
          this.clearTimer(); // Clear existing interval
          this.startTimer();

        }
        else{
          this.iscontinue=0;
          this.delectedAc=1;
          this.delMsg=otpdata.message;

        }


      } catch (error) {
        console.error('Error in Axios request:', error);
        // Handle the error as needed, e.g., show an error message to the user
      }
    },
    showToast() {
      // alert('yes');
      this.isinavalidotp = true;
      // Hide the toast after a certain duration
      setTimeout(() => {
        this.isinavalidotp = false;
      }, 3000); // Adjust the duration as needed
    },
    async VerifyOtp() {

      try {
        this.insideloader = true;
        const otpdata = await callAxios('https://jobspro.nithrajobs.com/api/auth/login', {
          phonenumber: this.mobileno,
          otp: this.otp
        }, 'post');
        this.insideloader = false;
        // console.log('otpdata',otpdata.status);
       if(otpdata.status == false){
         // alert(otpdata.message);
         this.showToast() ;
         // alert('error');
       }
       else {
         localStorage.setItem('token', otpdata.token);
         // localStorage.getItem('token')
         const inputString = otpdata.activity;
         const lastPart = inputString.split('.').pop();
         const url = otpdata.url;
//         const crypto = require('crypto');
//
// // Your secret key (keep this secret)
//         const secretKey = 'YourSecretKeyHere';
//         const encryptedUrl = this.encryptApiUrl(apiurl);
//         // this.urlData = url;
//         console.log(lastPart);
         // alert(lastPart);
         // eslint-disable-next-line no-empty
         if (lastPart === 'Employer_Dynamic_Home_Activity') {
           const encryptedString = this.encryptUrl(url);
           await this.$router.push(`/home-page?page=${encodeURIComponent(encryptedString)}`);
           localStorage.setItem('homeurl', otpdata.url);
         } else if (lastPart === 'Employer_Company_Register') {
           const encryptedString = this.encryptUrl(url);
           await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
         }
       }

      } catch (error) {
        console.error('Error in Axios request:', error);
      }
    },

//      encryptApiUrl(apiurl) {
//   const cipher = crypto.createCipher('aes-256-cbc', secretKey);
//   let encryptedApiUrl = cipher.update(apiurl, 'utf-8', 'hex');
//   encryptedApiUrl += cipher.final('hex');
//   return encryptedApiUrl;
// },

    mobileNumberEditButton() {
      // alert('krishna')
      this.$refs.myModal.hide();
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.mobileInput.focus();
        });
      }, 1000);


      // return

    },
    formatterFunction(e) {
      return String(e).substring(0, 10);
    },
    formatterotp(e) {
      return String(e).substring(0, 6);

    },

    validateMobileNumber() {
      this.mobileno = this.mobileno.replace(/\D/g, "");
      if (this.mobileno.length > 10) {
        // alert(('krishna'))
        this.mobileno = this.mobileno.slice(0, 10);
      }

      // Check if the input is a valid 10-digit number
      this.isMobileValid = /^\d{10}$/.test(this.mobileno);
      if(this.isMobileValid){
        this.isMobileErrorMsg=false;
      }
      else{
        this.isMobileErrorMsg=true;
      }
    },
    validateotp() {
      this.isOtpValid = /^\d{6}$/.test(this.otp);
      if(this.isOtpValid){
        this.isOtpErrorMsg=false;
        this.VerifyOtp();
      }
      else{
        this.isOtpErrorMsg=true;
      }
    },
    // onModalHide() {
    //   // This method is called when the modal is hidden
    //   console.log('Modal hidden');
    // },

    closeModal() {
      // Programmatic way to close the modal
      this.$refs.myModal.hide();
    },

    submitForm() {
      if (this.isMobileValid) {
        this.iscontinue=1;
        this.delectedAc=0;
        this.$refs.myModal.show(); // Show the modal if mobile number is valid
        this.GetMobileNumber = this.mobileno;
      } else {
        console.log('Mobile number is not valid. Form not submitted.');
      }
      // console.log('Form submitted successfully');
    },


    preLoading() {
      setTimeout(() => {
        this.showloading = false
      }, 2000)
    },
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar
    },

   async ResendOtp() {
      this.otp='';
     this.validateotp();
      const otpdata = await callAxios('https://jobspro.nithrajobs.com/api/auth/register', {
        phonenumber: this.mobileno
      }, 'post');
      console.log(otpdata)
      this.timeRemaining = 60;
      this.clearTimer(); // Clear existing interval
      this.startTimer()
    },

    startTimer() {
      // Update the timer every second
      this.timerInterval = setInterval(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--;
        } else {
          this.clearTimer();
        }
      }, 1000);
    },

    clearTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },

    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    },
  },



}
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none!important;
  margin: 0!important;
}

input[type="number"] {
  -moz-appearance: textfield!important;
}
</style>
<style>

.dashed-line-container {
  display: flex;
  align-items: center;
}

.dashed-line {
  flex: 1; /* Allow the dashed line to take up remaining space */
  border-top: 1px dashed #333; /* Dashed border color and style */
  margin: 0 10px; /* Add margin for spacing between dashes and text */
}

.text-inside {
  white-space: nowrap; /* Prevent the text from breaking to a new line */
  padding: 0 10px; /* Add padding for spacing between dashes and text */
}

.modal-header {
  display: none !important;
}

.modal-footer {
  display: none !important;
}

.centered-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.logincard {
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
  padding: unset!important;
  width: 100% !important;
  margin: auto;
}
.cardshawdow{
  //box-shadow: 0px 0px 30px #8F8F8F24;
  border-radius: 13px;
  padding: 20px;
  border: 1px solid #E8E8E8;
}
@media (min-width: 768px) {
  .logincard {
    //width: 50% !important;
    margin: auto;
  }


}
.redhead{
  color: #F4302D;
}
.h1title{
  font-size: 25px;
  text-align: left !important;
}
.sendotp,.VerifyOtp{

  float: right;
  background: #F4302D 0% 0% no-repeat padding-box !important;
  border-radius: 42px !important;
  border: unset !important;
}
.boldfont{
  font-weight: bold;
}
.otp-input {
  -webkit-appearance: none !important;

}
.otp-single-input{
  border-radius: 7px !important;
  border: unset !important;
  background: #1D3395 !important;
  color: white !important;
}

.editbtn{
  /* //margin: 5px; */
  color: black !important;
  background: white !important;
  padding: 5px 15px !important;
  border: 2px solid #0d6efd !important;
  /* //border-top: 2px solid blue!important; */
  /* //border-bottom: 3px solid blue!important; */
  /* //border-right: 3px solid blue!important; */
  border-radius: 5px;
  box-shadow: 0px 0px 30px #8F8F8F24;
  float: right;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  //background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* High z-index to ensure it overlaps other content */
}
</style>
